import { flowWithSafeComponent } from '@atlassian/jira-issue-view-common-utils/src/flow-with-safe-component/index.tsx';
import { connect } from '@atlassian/jira-issue-view-react-redux/src/index.tsx';
import { getChildIssuesPanelType } from '../../state/context/selectors.tsx';
import type { State } from '../../state/types.tsx';
import { ChildIssuesLimitPanel as View } from './main.tsx';

export const ChildIssuesLimitPanel = flowWithSafeComponent(
	connect((state: State, props: { hasExceededIssuesLimitInitialLoad: boolean }) => {
		// FIXME: JIV-17455 can be null
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		const childIssuesPanelType = getChildIssuesPanelType(state)!;

		return {
			childIssuesPanelType,
			hasExceededIssuesLimitInitialLoad: props.hasExceededIssuesLimitInitialLoad,
		};
	}, {}),
)(View);
